import z from 'zod';
export const paramTypeNameSchema = z.enum([
    "eq",
    "min",
    "mineq",
    "max",
    "maxeq",
    "bool",
    "range",
    "rangeeq",
    "in"
]);
// Schema per territorialId
// si deve adattare alla struttura 1-{codice_regione}-{codice_sovracomunale}-{codice_istat}
// Basandosi sull'ID territoriale gerarchico:
// - ID "1": Albero completo Italia con tutte le regioni, province e comuni
// - ID "1-XX": Regione specifica con province e comuni (es: "1-03" = Lombardia)
// - ID "1-XX-YYY": Provincia specifica con tutti i suoi comuni (es: "1-03-017" = Brescia)
// - ID "1-XX-YYY-ZZZZZZ": Comune specifico senza children (es: "1-03-017-017029" = Brescia città)
export const territorialIdSchema = z.string()
    .regex(/^1(-\d{2})?(-\d{3})?(-\d{6})?$/, "Deve essere un ID territoriale valido (es. '1', '1-03', '1-03-017', '1-03-017-017029')")
    .describe("ID territoriale composto es. '1-0001-0001'");
// Schema Zod per validare la stringa percentuale
export const percentageStringSchema = z.string()
    .regex(/^\d+(\.\d+)?%$/, "Deve essere una percentuale valida (es. '50%', '25.5%')")
    .describe("Percentuale come stringa es. '50%'");
export const dateStringSchema = z.string()
    .date()
    .transform((str) => new Date(str))
    .describe("Data in formato YYYY-MM-DD (es. '2023-10-01')");
/**
* Schema per il tipo value di ParamType
* Rappresenta tutti i possibili tipi di valore che può contenere un parametro
* Include tipi primitivi, array e oggetti complessi per diversi casi d'uso
*/
export const paramValueSchema = z.union([
    // stringa vuota
    z.string().min(0, "Il valore del parametro non può essere vuoto"),
    z.number(),
    z.boolean(),
    z.date(),
    z.array(z.string()), // lo metto per compatibilità con array di stringhe nelle API client
    z.array(z.number()),
    z.array(z.date()),
    z.array(dateStringSchema),
    // z.record(z.union([z.string(), z.number()]), z.union([z.string(), z.number()])),
    // territorialIdSchema,
    // z.array(territorialIdSchema),
    // z.array(percentageStringSchema)
]);
/**
* Schema base per ParamType
* Questi tipi rappresentano le diverse modalità di confronto e operazioni sui parametri
* Utilizzati per costruire query e gestire i parametri in modo tipizzato
* Ad esempio, nella tabella dei parametri, i tipi come "eq", "min", "max" rappresentano le operazioni di confronto
*/
export const paramTypeSchema = z.object({
    value: paramValueSchema
});
/**
* Schema per ParamTypeEq - uguale a =
* Nome nella tabella: eq
* Utilizzato per confronti di uguaglianza esatta
* Supporta numeri, date, ID territoriali e percentuali
*/
export const paramTypeEqSchema = z.object({
    value: z.union([z.number(), z.date(), percentageStringSchema])
});
/**
* Schema per ParamTypeMin - minore di <
* Nome nella tabella: min
* Utilizzato per confronti di valore minimo (esclusivo)
* Supporta numeri, date e percentuali
*/
export const paramTypeMinSchema = z.object({
    value: z.union([z.number(), z.date(), percentageStringSchema])
});
/**
* Schema per ParamTypeMinEq - minore o uguale <=
* Nome nella tabella: mineq
* Utilizzato per confronti di valore minimo (inclusivo)
* Supporta numeri, date e percentuali
*/
export const paramTypeMinEqSchema = paramTypeMinSchema;
/**
* Schema per ParamTypeMax - maggiore di >
* Nome nella tabella: max
* Utilizzato per confronti di valore massimo (esclusivo)
* Supporta numeri, date e percentuali
*/
export const paramTypeMaxSchema = z.object({
    value: z.union([z.number(), z.date(), percentageStringSchema])
});
/**
* Schema per ParamTypeMaxEq - maggiore o uguale >=
* Nome nella tabella: maxeq
* Utilizzato per confronti di valore massimo (inclusivo)
* Supporta numeri, date e percentuali
*/
export const paramTypeMaxEqSchema = paramTypeMaxSchema;
/**
* Schema per ParamTypeBoolean - booleano
* Nome nella tabella: bool
* Utilizzato per parametri che accettano solo valori true/false
* Supporta esclusivamente valori booleani
*/
export const paramTypeBooleanSchema = z.object({
    value: z.boolean()
});
/**
* Schema per ParamTypeRange - range di valori
* Nome nella tabella: range
* Utilizzato per definire intervalli di valori con estremi esclusivi
* Supporta range di numeri, date e percentuali come tuple
*/
export const paramTypeRangeSchema = z.object({
    value: z.union([
        z.tuple([z.number(), z.number()]),
        z.tuple([z.date(), z.date()]),
        z.tuple([percentageStringSchema, percentageStringSchema])
    ])
});
/**
* Schema per ParamTypeRangeEq - range con inclusione degli estremi
* Nome nella tabella: rangeeq
* Utilizzato per definire intervalli di valori con estremi inclusivi
* Supporta range di numeri, date e percentuali come tuple
*/
export const paramTypeRangeEqSchema = paramTypeRangeSchema;
/**
* Schema per ParamTypeIn - IN ( )
* Nome nella tabella: in
* Utilizzato per confronti con liste di valori (operatore SQL IN)
* Supporta array di numeri, date e ID territoriali
*/
export const paramTypeInSchema = z.object({
    value: z.union([
        z.array(z.number()),
        z.array(z.date())
    ])
});
//# sourceMappingURL=paramTypeSchema.js.map